module.exports = __webpack_public_path__ + "static/media/activeicon.ff755ddd.svg";